// extracted by mini-css-extract-plugin
module.exports = {"page":"Receipt_page_23Dxu"};